import authenticationReducer from './authentication/reducer';
import userReducer from './user/reducer';
import blocketLoginHelperReducer from './blocketLoginHelper/reducer';
import { actionCreators as authActionCreators } from './authentication/actions.js';
import { actionCreators as userActionCreators } from './user/actions.js';
import { actionCreators as blocketLoginHelperActionCreators } from './blocketLoginHelper/actions.js';
import { actionCreators as apiActionCreators } from './api/actions.js'; // eslint-disable-next-line import/prefer-default-export

export var getReducers = function getReducers() {
  return {
    authentication: {
      reducer: authenticationReducer
    },
    user: {
      reducer: userReducer
    },
    blocketLoginHelper: {
      reducer: blocketLoginHelperReducer
    }
  };
};
export var actionCreators = {
  authentication: authActionCreators,
  user: userActionCreators,
  blocketLoginHelper: blocketLoginHelperActionCreators,
  api: apiActionCreators
};
//# sourceMappingURL=index.js.map